const name = 'app_data'

class Store {
  /**
   * @class Store
   * @param config Object
   * {
   *   persistent: Boolean
   *   name: String
   * }
   * */
  constructor (config = {persistent: true, name}) {
    this.store = config.persistent ? localStorage : sessionStorage
    this.name = config.name || name
    this.create(config)
  }
  /**
   * Create store or get store if exists
   * @method create
   * @public
   * @returns Object
   */
  create () {
    !this.get() ? this.set() : this.get()
  }
  /**
   * Set storage item
   * @method set
   * @public
   * @param key String
   * @param value Any
   * @param callback Function
   * @returns Function
   */
  set (key, value, callback) {
    const store = this.getStore()
    if (key && value) {
      store[key] = value
    }
    this.store.setItem(this.name, JSON.stringify(store || {}))
    if (callback && typeof callback === 'function') {
      callback(this.get(key))
    }
  }
  /**
   * Get storage item
   * @method get
   * @public
   * @param key String
   * @returns Object
   */
  get (key) {
    const store = this.getStore()
    return key ? store[key] : store
  }
  /**
   * Remove storage item or the entire storage if key is not passed
   * @method remove
   * @public
   * @param key String
   * @param callback Function
   * @returns Function
   */
  remove (key, callback) {
    const store = this.getStore()
    if (key) {
      delete store[key]
      this.store.setItem(this.name, JSON.stringify(store))
      if (callback && typeof callback === 'function') {
        callback(key)
      }
      return
    }
    this.store.removeItem(this.name)
    if (callback && typeof callback === 'function') {
      callback(null)
    }
  }
  /**
   * Get store
   * @method getStore
   * @public
   * @returns Object
   */
  getStore () {
    return JSON.parse(this.store.getItem(this.name))
  }
}

export default Store



// WEBPACK FOOTER //
// ./src/bcq-ui/utils/store.js